import React, { useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { Box, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import '@styles/UserManagement/UserManagement.css';
import { postStaff } from "@services/api/users/userServices";
import { toast } from "react-toastify";

interface AddAdminModalProps {
  open: boolean;
  handleClose: () => void;
}

interface FormData {
  username: string;
  fullName: string;
  email: string;
  mobileNumber: string;
  role: string;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& #customized-dialog-title": {
    color: '#1E3966',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
  },
  "& .custom-dialog-content": {
    borderBottom: 'none',
  },
}));

const AddAdminModal: React.FC<AddAdminModalProps> = ({ open, handleClose }) => {
  // Initial form data state
  const [formData, setFormData] = useState<FormData>({
    username: "",
    fullName: "",
    email: "",
    mobileNumber: "",
    role: ""
  });

  // Handle input change for all fields
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown }>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name as string]: value
    });
  };

  // Handle role change (for the Select component)
  const handleRoleChange = (e: SelectChangeEvent<string>) => {
    setFormData({
      ...formData,
      role: e.target.value
    });
  };

  // Function to handle form submission (for Save button)
  const handleSave = async () => {
    console.log("Form data submitted:", formData);
    try {
      const res = await postStaff(formData);
      toast.success(res);
      setFormData({
        username: "",
        fullName: "",
         email: "",
         mobileNumber: "",
         role: ""
      })
      handleClose(); // Close the modal after saving
    }catch(error){
      toast.error("Unable to add Admin/Staff");
      handleClose();
    }
  };
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          New Admin
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers className="custom-dialog-content">
          <Box
            sx={{
              width: 400,
              maxWidth: "100%",
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              marginLeft: '10px',
              marginRight: "10px",
              padding: "0px"
            }}
          >
            <div>
              <label className="adminmodallable">Username</label>
              <TextField
                fullWidth
                size="small"
                id="Username"
                name="username"
                placeholder="Enter Name"
                value={formData.username}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label className="adminmodallable">Full Name</label>
              <TextField
                fullWidth
                size="small"
                id="fullName"
                name="fullName"
                placeholder="Enter Name"
                value={formData.fullName}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label className="adminmodallable">Email</label>
              <TextField
                fullWidth
                size="small"
                id="email"
                name="email"
                placeholder="Enter email id"
                value={formData.email}
                onChange={handleInputChange}
                type="email"
              />
            </div>
            <div>
              <label className="adminmodallable">Mobile Number</label>
              <TextField
                fullWidth
                size="small"
                id="email"
                name="mobileNumber"
                placeholder="Enter email id"
                value={formData.mobileNumber}
                onChange={handleInputChange}
                type="number"
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label className="adminmodallable">Role</label>
              <Select
                value={formData.role}
                onChange={handleRoleChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                size="small"
                fullWidth
              >
                <MenuItem value="">Select Role</MenuItem>
                <MenuItem value="SermybleAdmin">Admin</MenuItem>
                <MenuItem value="SermybleStaff">Staff</MenuItem>
              </Select>
            </div>

          </Box>
        </DialogContent>
        <DialogActions sx={{ marginBottom: "15px", marginRight: '10px' }}>
          <Button
            variant="outlined"
            autoFocus
            onClick={handleClose}
            sx={{
              border: "1px solid #CBCBCB",
              backgroundColor: "white",
              color: "#575757",
              marginRight: '5px',
              textTransform: "capitalize",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            autoFocus
            onClick={handleSave} // Save action
            sx={{
              border: "1px solid #CBCBCB",
              backgroundColor: "#1E3966",
              textTransform: "capitalize",
              color: "white",
              '&:hover': {
                backgroundColor: '#163253',  // A slightly darker shade of the original blue
                borderColor: '#A0A0A0'       // A lighter gray for the border
              }
            }}
          >
            Save
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}

export default AddAdminModal;
